// src/admin/AdminPanel.js
import React from "react";
import {
  Admin,
  defaultTheme,
  Layout,
  Sidebar,
  Menu,
  MenuItemLink,
  Resource,
} from "react-admin";
import { deepmerge } from "@mui/utils";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import AdminSettings from "./Admin/AdminSettings";
import BookIcon from "@mui/icons-material/Book";
import { UserResource, userDataProvider } from "./Admin/resources/AdminUsers";

// Custom theme
const myCustomTheme = deepmerge(defaultTheme, {
  typography: {
    fontFamily: '"Plus Jakarta Sans", sans-serif',
  },
});

// Custom Sidebar
const CustomSidebar = (props) => {
  /* const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm")); */
  return (
    <Sidebar
      {...props}
      sx={{
        width: 200, // narrow sidebar
        "& .MuiDrawer-paper": { width: 80, overflowX: "hidden" },
      }}
    >
      <Menu>
        <MenuItemLink
          to="/"
          primaryText="Exit Admin Panel"
          leftIcon={<DashboardIcon />}
          sx={{ justifyContent: "center", "& span": { display: "none" } }}
        />
        <MenuItemLink
          to="/admin/users"
          primaryText="Users"
          leftIcon={<BookIcon />}
          sx={{ justifyContent: "center", "& span": { display: "none" } }}
        />
        <MenuItemLink
          to="/admin/settings"
          primaryText="Settings"
          leftIcon={<SettingsIcon />}
          sx={{ justifyContent: "center", "& span": { display: "none" } }}
        />

        {/* Add more resources here if needed */}
      </Menu>
    </Sidebar>
  );
};

// Custom Layout
const CustomLayout = (props) => <Layout {...props} sidebar={CustomSidebar} />;

export default function AdminPanel() {
  return (
    <div style={{ width: "100%" }}>
      <Admin
        basename="/admin"
        dataProvider={userDataProvider}
        theme={myCustomTheme}
        layout={CustomLayout} // use custom layout
      >
        {UserResource}
        <Resource
          name="settings"
          options={{ label: "Settings" }}
          list={AdminSettings}
        />
      </Admin>
    </div>
  );
}
